import Vue from 'vue'
import Vuex from 'vuex'
import { Magic } from 'magic-sdk'

import axios from 'axios';

Vue.use(Vuex)

const m = new Magic(process.env.VUE_APP_MAGIC_KEY)

export default new Vuex.Store({
	state: {
		user: null,
	},
	mutations: {
		SET_USER_DATA(state, userData) {
			state.user = { token: userData.token, email: userData.email, id: userData.id }
			localStorage.setItem('leadgem_token', JSON.stringify(userData.token))
			localStorage.setItem('leadgem_id', JSON.stringify(userData.id))
			localStorage.setItem('leadgem_email', JSON.stringify(userData.email))
		},
		CLEAR_USER_DATA() {
			localStorage.removeItem('leadgem_token')
			localStorage.removeItem('leadgem_id')
			localStorage.removeItem('leadgem_email')
			location.reload()
		},
	},
	actions: {
		async signup({ commit }, user) {
			// log in
			await m.auth.loginWithMagicLink({
				email: user.email,
				showUI: true
			})
			const data = await m.user.getMetadata()

			const { id } = (await axios.post(
		        process.env.VUE_APP_API_URL + 'users/',
						{
							email: user.email,
							token: user.token.id,
							issuer: data.issuer
						}
		      )).data

			const magicToken = await m.user.getIdToken({ lifespan: 86400 })
			commit('SET_USER_DATA', { token: magicToken, email: user.email, id: id})
		},
		async login({ commit }, email) {
			// log in
			await m.auth.loginWithMagicLink(email)
			const magicToken = await m.user.getIdToken({ lifespan: 86400 })
			const { id } = (await axios.get(process.env.VUE_APP_API_URL + 'users/' + email.email, { headers: { 'Authorization': `Bearer ${magicToken}`}})).data
			commit('SET_USER_DATA', { token: magicToken, email: email.email, id: id })
		},
		async logout({ commit }) {
			await m.user.logout()
			commit('CLEAR_USER_DATA')
		},
	},
	modules: {},
})
